/*
 * Copyright (c) 2023. iSecNew10 Enterprises LLC
 */

import React, {useEffect, useState} from 'react'

import './NotFound.css'
import Constants from '../Constants';

const NotFoundPage = () => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!loaded) {
            Constants.setLoading(true)
            setLoaded(true);
        } else {
            Constants.setLoading(false)
        }
    }, []);

    return loaded ? (
        <div className="message-page">
            <h1 className="title">404</h1>
            <h2 className="message">Not Found</h2>
        </div>
    ) : null
}

export default NotFoundPage
